import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectTokenValidityCheck = createSelector([(state: AppState) => state.shared.tokenValidityCheck], ({ data, fetching }) => ({
  data,
  fetching,
}));
